module.exports = "<div class=\"app-container\">\n    <p>\n        dashboard works!\n\n        LOAD ACTIVE CLASS AS DEFAULT CASS\n      </p>\n</div>\n"